// Mock data for Le Cosmos Saint-Étienne

export const restaurantInfo = {
  name: "Le Cosmos Saint-Étienne",
  tagline: "Tacos & Burgers halal — Rapide, généreux, savoureux.",
  rating: 4.6,
  totalReviews: 272,
  priceRange: "1–10€ / personne",
  address: "49 Av. de la Libération, 42000 Saint-Étienne",
  plusCode: "C9QV+FP Saint-Étienne",
  phone1: "04 87 66 22 41",
  phone: "04 87 66 22 41",
  freeDeliveryFrom: "15€",
  socialMedia: {
    snapchat: "cosmos_officiel",
    facebook: "Le Cosmos Saint Etienne"
  },
  deliveryLinks: {
    uberEats: "https://www.ubereats.com/fr/store/le-cosmos/dPHYzs4_Xhub5DVsnjrgnQ?msockid=34f63074cd526d481414251ccc486c75",
    deliveroo: "https://deliveroo.fr/fr/menu/saint-etienne/ste-saint-etienne-centre-ville/le-cosmos"
  }
};

export const hours = {
  lundi: [{ open: "11:00", close: "14:30" }, { open: "18:00", close: "23:30" }],
  mardi: [{ open: "11:00", close: "14:30" }, { open: "18:00", close: "23:30" }],
  mercredi: [{ open: "11:00", close: "14:30" }, { open: "18:00", close: "23:30" }],
  jeudi: [{ open: "11:00", close: "14:30" }, { open: "18:00", close: "23:30" }],
  vendredi: [{ open: "11:00", close: "13:00" }, { open: "18:00", close: "00:00" }],
  samedi: [{ open: "18:00", close: "00:00" }],
  dimanche: [{ open: "18:00", close: "23:30" }]
};

export const tacosMenu = {
  title: "Compose ton Tacos / Roulé",
  description: "Nos tacos et roulés sont garnis de sauce gruyère et de frites.",
  formats: [
    { name: "Simple", description: "1 viande", price: 7.90, isPopular: true },
    { name: "Maxi Tacos", description: "2 viandes", price: 10.90, isPopular: true },
    { name: "Roulé", description: "1 viande", price: 8.90 }
  ],
  menuOption: 2.50,
  meats: [
    { name: "Escalope nature", extra: 0 },
    { name: "Escalope thaï", extra: 0 },
    { name: "Cordon bleu", extra: 0 },
    { name: "Steak", extra: 0 },
    { name: "Nuggets", extra: 0 },
    { name: "Tenders", extra: 1.00 },
    { name: "Kebab", extra: 1.00 }
  ],
  sauces: [
    "Algérienne", "Mayonnaise", "Ketchup", "Samouraï", "Curry", 
    "Blanche", "Tartare", "Harissa", "Barbecue", "Chili thaï", "Burger"
  ],
  supplements: [
    "Raclette", "Boursin", "Kiri", "Mozza", "Cheddar", 
    "Chèvre", "Emmental", "Œuf", "Bleu", "Olives", "Poivrons", "Piment"
  ],
  supplementPrice: 0.80,
  gratinage: [
    { type: "Simple", price: 1.80 },
    { type: "Maxi Tacos", price: 2.30 },
    { type: "Roulé", price: 1.80 }
  ],
  gratinageOptions: [
    "Jambon de dinde – Raclette",
    "Chèvre – Miel",
    "Sauce tomate – Mozza",
    "Emmental – Bacon"
  ]
};

export const burgers = [
  {
    name: "Burger Boucher",
    description: "Steak façon bouchère 120g, cheddar, pain brioché",
    priceSeul: 7.50,
    priceMenu: 10.00,
    image: "https://images.unsplash.com/photo-1550547660-d9450f859349?w=800&q=80",
    isPopular: true
  },
  {
    name: "Chicken",
    description: "Chicken pané, cheddar",
    priceSeul: 5.50,
    priceMenu: 8.00,
    image: "https://images.unsplash.com/photo-1603508102983-99b101395d1a?w=800&q=80"
  },
  {
    name: "Cheese",
    description: "Steak 45g, cheddar",
    priceSeul: 3.20,
    priceMenu: 5.70,
    image: "https://images.unsplash.com/photo-1654009782508-b3c526a36120?w=800&q=80"
  },
  {
    name: "Double Burger Boucher",
    description: "2 steaks façon bouchère 120g, cheddar, pain brioché",
    priceSeul: 8.50,
    priceMenu: 11.00,
    image: "https://images.unsplash.com/photo-1550547660-d9450f859349?w=800&q=80"
  },
  {
    name: "Bap's",
    description: "2 steaks 45g, rösti, cheddar",
    priceSeul: 6.50,
    priceMenu: 9.00,
    image: "https://images.unsplash.com/photo-1603508102983-99b101395d1a?w=800&q=80"
  },
  {
    name: "Double Cheese",
    description: "2 steaks 45g, cheddar",
    priceSeul: 5.00,
    priceMenu: 7.50,
    image: "https://images.unsplash.com/photo-1654009782508-b3c526a36120?w=800&q=80"
  },
  {
    name: "Burger Bacon",
    description: "Steak façon bouchère 120g, bacon, cheddar, pain brioché",
    priceSeul: 8.00,
    priceMenu: 10.50,
    image: "https://images.unsplash.com/photo-1550547660-d9450f859349?w=800&q=80"
  },
  {
    name: "Chicken Bap's",
    description: "Chicken pané, rösti, cheddar",
    priceSeul: 6.50,
    priceMenu: 9.00,
    image: "https://images.unsplash.com/photo-1603508102983-99b101395d1a?w=800&q=80"
  },
  {
    name: "Triple Cheese",
    description: "3 steaks 45g, cheddar",
    priceSeul: 6.50,
    priceMenu: 9.00,
    image: "https://images.unsplash.com/photo-1654009782508-b3c526a36120?w=800&q=80"
  }
];

export const sharingMenu = [
  { name: "Tenders x3", price: 7.00 },
  { name: "Pop crevettes x10", price: 4.20 },
  { name: "Nuggets x5", price: 4.20 },
  { name: "Bouchées camembert x5", price: 4.20 },
  { name: "Mozza stick x5", price: 4.20 },
  { name: "Jalapeños x5", price: 4.20 },
  { name: "Frites", price: 2.50 },
  {
    name: "Box Mix",
    price: 8.50,
    description: "3 mozza stick, 3 bouchées camembert, 2 jalapeños, 5 pop crevettes"
  }
];

export const kidsMenu = {
  name: "Menu Enfant",
  price: 6.50,
  items: "5 nuggets ou 1 cheese + frites + 1 Capri-Sun + 1 œuf en chocolat"
};

export const desserts = [
  { name: "Tiramisu", price: 3.50 },
  { name: "Tarte au Daims", price: 3.50 },
  { name: "Fondant chocolat", price: 3.50 },
  { name: "Glace Ben & Jerry's 100ml", price: 4.00 },
  { name: "Glace Ben & Jerry's 500ml", price: 7.00 }
];

export const drinks = [
  { name: "Boisson 33cl", price: 1.90 },
  { name: "Boisson 50cl", price: 2.60 },
  { name: "Boisson 1,25L", price: 3.80 }
];

export const lunchDeal = {
  name: "Menu Midi",
  price: 5.50,
  description: "Tacos + canette",
  badge: "OFFRE MIDI",
  isPopular: true,
  isBestSeller: true
};

export const services = [
  { icon: "Accessibility", title: "Accessible", description: "Entrée accessible en fauteuil roulant" },
  { icon: "Armchair", title: "Terrasse", description: "Profitez de notre terrasse" },
  { icon: "PackageCheck", title: "Livraison sans contact", description: "Sécurité garantie" },
  { icon: "Bike", title: "Livraison", description: "Livraison rapide" },
  { icon: "Car", title: "Drive", description: "Service drive disponible" },
  { icon: "ShoppingBag", title: "À emporter", description: "Commandez et récupérez" },
  { icon: "UtensilsCrossed", title: "Sur place", description: "Repas sur place" },
  { icon: "Clock", title: "Ouvert tard", description: "Service tardif" },
  { icon: "Leaf", title: "Options végétariennes", description: "Plats végétaliens et végétariens" },
  { icon: "Star", title: "Halal", description: "100% halal certifié" },
  { icon: "Users", title: "Groupes bienvenus", description: "Familles, étudiants, touristes" },
  { icon: "CreditCard", title: "Tous paiements", description: "CB, mobile NFC, Pluxee, tickets resto" }
];

export const reviews = [
  {
    author: "Client satisfait",
    rating: 5,
    text: "Accueil chaleureux, patron cool, employés au top !",
    date: "Il y a 2 semaines"
  },
  {
    author: "Amateur de tacos",
    rating: 5,
    text: "Tacos excellents, bien garnis et savoureux. Je recommande !",
    date: "Il y a 1 mois"
  },
  {
    author: "Client livraison",
    rating: 5,
    text: "Livraison parfaite, très chaud, copieux. Merci pour le trajet !",
    date: "Il y a 3 semaines"
  }
];

export const faqData = [
  {
    question: "Tous vos produits sont-ils halal ?",
    answer: "Oui, 100% de nos produits sont halal certifiés. Nous nous engageons à servir uniquement de la viande halal de qualité."
  },
  {
    question: "Avez-vous des options végétariennes ou véganes ?",
    answer: "Oui, nous proposons des options végétariennes et végétaliennes. Vous pouvez composer votre tacos sans viande avec nos légumes et fromages."
  },
  {
    question: "Le service drive est-il disponible ?",
    answer: "Oui, notre service drive est disponible pendant les horaires d'ouverture. Appelez-nous pour passer commande avant de venir."
  },
  {
    question: "Quelle est la zone de livraison ?",
    answer: "Nous livrons dans toute la zone de Saint-Étienne. La livraison est gratuite à partir de 15€ selon le secteur. Commandez via Uber Eats ou Deliveroo."
  },
  {
    question: "Quels sont vos horaires d'ouverture ?",
    answer: "Lundi à jeudi : 11h-14h30 et 18h-23h30 | Vendredi : 11h-13h et 18h-00h | Samedi : 18h-00h | Dimanche : 18h-23h30"
  }
];
